import React from 'react';

import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

const carouselItemHeight = 120;
const carouselItemWidth = 332;
export const CarouselSkeleton = () => (
    <Box
        width={carouselItemWidth}
        height={carouselItemHeight}
        borderRadius={'r20'}
        backgroundColor={ds.colorToken.background.neutral.subtler}
    >
        <LoadingSkeleton
            width={carouselItemWidth}
            height={carouselItemHeight}
            borderRadius="r20"
            skeletonColor={designSystem.colors.neutral300}
        />
    </Box>
);
